/*
 * Module for the user contexts modal
 */

define([
  "marionette",
  "jquery",
  "backbone",
  "messaging/messenger",
  "modules/admin/userAdministration/userDetails/contextMapDisplay/contextMapView",
], function (Marionette, $, Backbone, Messenger, ContextMapView) {
  var ContextMapController = Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.contextMap = options.contextMap;
      this.name = "contextMapModule";
      this.editMode = options.editMode;
      this.isTenantAdmin = false; //boolean representing whether the edited user is a tenant admin
      this._setUpVents();
    },
    show: function (kbId) {
      var list = this.contextMap.where({ kbId: kbId });

      if (list.length === 0) {
        var kbContexts = Messenger.reqres.request("fetch:kb:contexts", kbId);
        kbContexts.onSynced(function () {
          // For a new user, make sure the context list is selected by default
          for (var i = 0; i < kbContexts.length; i++) {
            this.contextMap.createUserContext(
              kbContexts.at(i).get("id"),
              kbContexts.at(i).get("status"),
              kbId,
            );
            var model = this.contextMap.findWhere({ contextId: kbContexts.at(i).get("id") });
            model.set("hasPermissions", true);
          }

          list = this.contextMap.where({ kbId: kbId });
          this._continueShow(list);
        }, this);
      } else {
        this._continueShow(list);
      }
    },
    _continueShow: function (list) {
      var collection = new Backbone.Collection(list);

      //check if the edited user is a tenant admin. If so, then make it look like all the contexts
      //are enabled and disable the checkboxes from being edited.
      collection.isTenantAdmin = this.isTenantAdmin;
      collection.editMode = this.editMode;

      this.view = new ContextMapView.contextMapView({ collection: collection });

      this.view.on(
        "show",
        function () {
          this._showSubViews();
        },
        this,
      );

      this.view.on(
        "click:context",
        function (contextId) {
          var model = this.contextMap.findWhere({ contextId: +contextId });
          model.set("hasPermissions", !model.get("hasPermissions"));
          this.view.render();
        },
        this,
      );

      this.showRegion(this.view);
    },
    _showSubViews: function () {},
    _setUpVents: function () {
      //Whenever a different KB is selected, we re-initialize the show method,
      //with the new KB.  This will refresh the module appropriately.
      Messenger.vent.on(
        "change:selected:kb",
        function (newKbId) {
          //save old stuff
          //display new stuff
          this.contextMap.onSynced(function () {
            this.show(newKbId);
          }, this);
        },
        this,
      );

      //Register when the edited user has the tenant admin property changed
      //Also called when the user details modal first loads, in which case this
      //module may not be shown yet.
      Messenger.vent.on(
        "changed:edited:user:tenant:admin",
        function (isTenantAdmin) {
          this.isTenantAdmin = isTenantAdmin;
          if (this.view) {
            this.view.collection.isTenantAdmin = isTenantAdmin;
            this.view.render();
          }
        },
        this,
      );
    },
  });

  return ContextMapController;
});
